import { useState, useEffect } from "react";

function FadingText({ newText }) {
  const [text, setText] = useState(newText);
  const [fade, setFade] = useState("fade-in");

  useEffect(() => {
    if (newText !== text) {
      setFade("fade-out");
      const timeout = setTimeout(() => {
        setText(newText);
        setFade("fade-in");
      }, 300);
      return () => clearTimeout(timeout);
    }
  }, [newText]);

  return (
    <div className={fade}>
      {text}
      <style jsx>{`
        .fade-in {
          opacity: 1;
          transition: opacity 0.3s;
        }
        .fade-out {
          opacity: 0;
          transition: opacity 0.3s;
        }
      `}</style>
    </div>
  );
}
export default FadingText;
